// LoadingDots.jsx
import React from 'react';

export default function LoadingDots() {
  return (
    <span style={{ display: 'inline-block' }}>
      {['0s','0.2s','0.4s'].map((delay, i) => (
        <span
          key={i}
          style={{
            display: 'inline-block',
            animation: `blink 1s ${delay} infinite`,
            fontWeight: 'bold'
          }}
        >.</span>
      ))}
      <style>{`
        @keyframes blink {
          0%,20% { opacity: 0; }
          50%    { opacity: 1; }
          100%   { opacity: 0; }
        }
      `}</style>
    </span>
  );
}